import * as echarts from 'echarts/core'

import { BarChart, PieChart, ScatterChart, LineChart, MapChart, RadarChart, CustomChart, TreemapChart } from 'echarts/charts'

import { TitleComponent, TooltipComponent, GridComponent, ToolboxComponent, LegendComponent, DataZoomComponent, MarkLineComponent, GraphicComponent, VisualMapComponent } from 'echarts/components'

// import { LabelLayout, UniversalTransition } from "echarts/features";

// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers'

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
  LegendComponent,
  DataZoomComponent,
  MarkLineComponent,
  GraphicComponent,
  VisualMapComponent,
  CanvasRenderer,
  SVGRenderer,

  BarChart,
  PieChart,
  ScatterChart,
  LineChart,
  MapChart,
  RadarChart,
  CustomChart,
  TreemapChart
])

// 导出
export default echarts
